;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { OfferOrdering } from '@qogita/canary-client/sellers'
import { CanaryClient } from '@qogita/deprecated-canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { PAGE_SIZE } from 'src/deprecated/constants'
import { getStocklistSourceOffersQueryKey } from 'src/deprecated/utils/queryKey'

const getStocklistSourceOffers = ({
  sourceQid,
  page,
  pageSize,
  brands,
  ordering,
  canaryClient,
}: {
  sourceQid: string
  page: number
  pageSize: number
  brands?: string[]
  ordering?: OfferOrdering
  canaryClient: CanaryClient
}) =>
  canaryClient.getStocklistSourceOffers({
    sourceQid,
    page,
    pageSize,
    brands,
    ordering,
  })

const getStocklistSourceOffersQueryOptions = ({
  sourceQid,
  page,
  pageSize,
  brands,
  ordering,
  canaryClient,
}: {
  sourceQid: string
  page: number
  pageSize: number
  brands?: string[]
  ordering?: OfferOrdering
  canaryClient: CanaryClient
}) =>
  // TODO: resolve this by moving to RSC or adding the missing dependency
  // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  queryOptions({
    queryKey: getStocklistSourceOffersQueryKey(
      sourceQid,
      page,
      pageSize,
      brands,
      ordering,
    ),
    queryFn: () =>
      getStocklistSourceOffers({
        sourceQid,
        page,
        pageSize,
        brands,
        ordering,
        canaryClient,
      }),
  })

export const useGetStocklistSourceOffers = ({
  sourceQid,
  page,
  pageSize = PAGE_SIZE,
  brands,
  ordering,
  enabled,
}: {
  sourceQid: string | undefined
  page: number
  pageSize?: number
  brands?: string[]
  ordering?: OfferOrdering
  enabled?: boolean
}) => {
  const canaryClient = useCanaryClient()

  return useQuery({
    ...getStocklistSourceOffersQueryOptions({
      sourceQid: sourceQid ?? '',
      page,
      pageSize,
      brands,
      ordering,
      canaryClient,
    }),
    enabled: enabled && Boolean(sourceQid),
    placeholderData: (previous) => previous,
  })
}
